import { useEffect, useState, lazy, Suspense } from "react";
import FooterSection from "assets/Footer";
import Navbar from "assets/Navbar";
// import CardDesign from "components/cardDesign";

import QuickAddDrawer from "components/quickAddDrawer";
import StockOut from "components/stockOut";
import useFooterData from "hook/useFooterData";
import useProductDetailsData from "hook/useProductDetailsData";
import useProductsByCatalogue from "hook/useProductsByCatalogue";
import { Helmet } from "react-helmet";
import { AiFillTikTok } from "react-icons/ai";
import { BiPhone, BiPhoneCall } from "react-icons/bi";
import { BsTruck } from "react-icons/bs";
import {
  FaFacebook,
  FaInstagram,
  FaShoppingCart,
  FaWhatsapp,
  FaYoutube,
  FaMinus,
  FaPlus,
  FaPhone,
} from "react-icons/fa";
import { FaHeadphones } from "react-icons/fa6";
import { TbCurrencyTaka } from "react-icons/tb";
import { useNavigate, useParams } from "react-router-dom";
import ProductDetailsShimmer from "components/shimmer/productDetailsShimmer";
import ScreenScrollToTop from "../components/ScreenScrollToTop";
import { getCartItems, setCartItems } from "utils/cartStorage";

const CardDesign = lazy(() => import("components/cardDesign"));

const ProductDetails = () => {
  const { category, id } = useParams();
  const { products, loading, error } = useProductsByCatalogue(category);
  const [sizes, setSizes] = useState([]);
  const [selectedSize, setSelectedSize] = useState("");
  const [colors, setColors] = useState([]);
  const [selectedColor, setSelectedColor] = useState("");
  const [variants, setVariants] = useState([]);
  const [selectedVariant, setSelectedVariant] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const tabs = ["DESCRIPTION"];
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const { footerData, loadingFooter } = useFooterData();
  const { detailsData, loadingDetails } = useProductDetailsData(id);
  const navigate = useNavigate();

  const [showFullDescription, setShowFullDescription] = useState(false);

  /* ---------------- INITIAL LOAD ---------------- */
  useEffect(() => {
    if (!detailsData) return;
    if (detailsData.size) {
      const sizeArray = detailsData.size.split(",").map((s) => s.trim()) || [];
      setSizes(sizeArray);
      setSelectedSize(sizeArray[0]);
    }
    if (detailsData.color) {
      const colorArray =
        detailsData.color.split(",").map((c) => c.trim()) || [];
      setColors(colorArray);
      setSelectedColor(colorArray[0]);
    }
    if (detailsData.variants?.length) {
      setVariants(detailsData.variants);

      const firstVariant = detailsData.variants[0];
      setSelectedVariant(firstVariant);
      setSelectedImage({
        type: "image",
        variant: firstVariant,
        thumb: `https://backend.nuhababy.com/${firstVariant.images[0].thumb}`,
        original: `https://backend.nuhababy.com/${firstVariant.images[0].original}`,
      });
    }
  }, [detailsData]);

  useEffect(() => {
    if (!detailsData || !selectedVariant) return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: "BDT",
        value: selectedVariant?.flashPrice || selectedVariant?.discount || 0,
        items: [
          {
            item_id: detailsData.item_id,
            item_name: selectedVariant.title,
            price:
              selectedVariant?.flashPrice || selectedVariant?.discount || 0,
            item_category: detailsData.catalogue_title,
            item_variant: selectedVariant.title,
          },
        ],
      },
    });

    console.log("view_item fired");
  }, [detailsData, selectedVariant]);

  if (loadingDetails || loadingFooter) return <ProductDetailsShimmer />;

  // const allImages = variants.flatMap((variant) =>
  //   variant.images.map((img) => ({ variant, img })),
  // );
  const allMedia = [
    // Images from variants
    ...variants.flatMap((variant) =>
      variant.images.map((img) => ({
        type: "image",
        variant,
        thumb: `https://backend.nuhababy.com/${img.thumb}`,
        original: `https://backend.nuhababy.com/${img.original}`,
      })),
    ),

    // Videos from item
    ...(detailsData?.video_path || []).map((video) => ({
      type: "video",
      variant: variants[0], // attach first variant
      src: video,
    })),
  ];
  const product = detailsData;
  const isOutOfStock = product.status === "unavailable";
  const currentTitle = selectedVariant?.title;
  const currentPrice = selectedVariant?.discount || selectedVariant?.flashPrice;
  const originalPrice = selectedVariant?.flashPrice;
  const freeVariantDelivery = selectedVariant?.freeVariantDelivery;

  const discountPercent =
    currentPrice > 0
      ? Math.ceil(((currentPrice - originalPrice) / currentPrice) * 100)
      : 0;

  // const images = selectedVariant?.images || [];
  const currentImage =
    selectedImage?.type === "image"
      ? selectedImage.original
      : selectedImage?.src || "";

  const whatsappMessage = `
*${currentTitle}*
Price: ${originalPrice}৳
${window.location.href}
Thank You!
`;

  const getTabContent = () => {
    switch (activeTab) {
      case "DESCRIPTION":
        const description = product?.description ?? "";
        const shortText = description.slice(0, 350); // কতটুকু দেখাবে প্রথমে

        const isLong = description.length > 350;

        return (
          <div className="max-w-5xl mx-auto text-sm leading-6 text-gray-700 mt-4">
            <p className="whitespace-pre-line">
              {showFullDescription || !isLong ? description : shortText + "..."}
            </p>

            {isLong && (
              <button
                onClick={() => setShowFullDescription(!showFullDescription)}
                className="mt-2 text-[#265fc9] font-semibold hover:underline"
              >
                {showFullDescription ? "View Less" : "View More"}
              </button>
            )}
          </div>
        );
      default:
        return null;
    }
  };

  const handleAddToCart = (e) => {
    e.stopPropagation();
    setDrawerOpen(true);
    const price = selectedVariant?.flashPrice || selectedVariant?.discount || 0;

    // ✅ FIRE ADD TO CART EVENT
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "BDT",
        value: price * quantity,
        items: [
          {
            item_id: detailsData.item_id,
            item_name: selectedVariant.title,
            price: price,
            item_category: detailsData.catalogue_title,
            item_variant: selectedVariant.title,
            quantity: quantity,
          },
        ],
      },
    });

    console.log("add_to_cart fired");
    // Get existing cart from localStorage
    const cart = getCartItems();

    // Unique key per item + variant
    const key = `${detailsData.item_id}_${selectedVariant.variant_id}`;

    // Check if item already exists in cart
    const index = cart.findIndex((item) => item.cartKey === key);

    if (index !== -1) {
      // If exists, increase quantity
      cart[index].quantity += quantity;
    } else {
      // Push full item details into cart
      cart.push({
        item_id: detailsData.item_id,
        catalogue: detailsData.catalogue,
        catalogue_title: detailsData.catalogue_title,
        color: detailsData.color,
        description: detailsData.description,
        extraDescription: detailsData.extraDescription,
        flashOffer: detailsData.flashOffer,
        quantity: quantity,
        material: detailsData.material,
        selectedColor: selectedColor,
        selectedPrice: selectedVariant.flashPrice,
        selectedSize: selectedSize,
        selectedTitle: selectedVariant.title,
        selectedVariant: selectedVariant,
        size: detailsData.size,
        status: detailsData.status,
        subCatalogue: detailsData.subCatalogue,
        subCatalogue_title: detailsData.subCatalogue_title,
        variant: detailsData.variant,
        weight: detailsData.weight,
        video_path: detailsData.video_path,
        image: currentImage, // if you have a main image for display
      });
    }

    // Save back to localStorage
    setCartItems(cart);
  };

  // --- Order Now Handler ---
  const handleOrderNow = (e) => {
    handleAddToCart(e);
    navigate("/orderDetails");
  };

  return (
    <>
      <Helmet>
        <meta property="og:title" content={currentTitle} />
        <meta
          property="og:description"
          content={`Buy ${currentTitle} for ${currentPrice}৳`}
        />
        <meta property="og:image" content={currentImage} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="product" />
      </Helmet>

      <div className="bg-gray-100">
        <Navbar />

        <div className="container mx-auto flex flex-col md:flex-row p-4 gap-4 md:mt-5 mt-2 ">
          {/* Left Panel */}

          <div className="w-full md:w-1/2 flex flex-col items-center">
            {currentImage && (
              <div className="relative inline-block">
                {selectedImage?.type === "image" ? (
                  <img
                    src={currentImage}
                    alt={currentTitle}
                    width={600}
                    height={800}
                    loading="eager"
                    fetchPriority="high"
                    decoding="async"
                    className={`md:h-[600px] h-[400px] object-cover rounded-xl mb-4 ${
                      isOutOfStock ? "opacity-40" : ""
                    }`}
                  />
                ) : (
                  <video
                    src={currentImage}
                    controls
                    autoPlay
                    controlsList="nodownload noplaybackrate"
                    onContextMenu={(e) => e.preventDefault()}
                    className="md:h-[600px] h-[400px] object-cover rounded-xl mb-4"
                  />
                )}

                {isOutOfStock && <StockOut />}
              </div>
            )}

            {allMedia.length > 1 && (
              <div className="flex items-center justify-center gap-2 w-full overflow-hidden">
                <div className="flex gap-2 overflow-x-auto">
                  {allMedia.map((item, idx) => {
                    const url = item.type === "image" ? item.thumb : item.src;

                    return item.type === "image" ? (
                      <img
                        key={idx}
                        alt={`Thumb ${idx}`}
                        src={url}
                        loading="lazy"
                        decoding="async"
                        className={`w-20 h-20 object-cover rounded-md cursor-pointer border-2 ${
                          selectedImage?.src === item.src
                            ? "border-blue-500"
                            : "border-transparent"
                        }`}
                        onClick={() => {
                          setSelectedVariant(item.variant);
                          setSelectedImage(item);
                        }}
                      />
                    ) : (
                      <div
                        key={idx}
                        className={`relative w-20 h-20 border-2 rounded-md cursor-pointer overflow-hidden ${
                          selectedImage?.src === item.src
                            ? "border-blue-500"
                            : "border-transparent"
                        }`}
                        onClick={() => {
                          setSelectedVariant(item.variant);
                          setSelectedImage(item);
                        }}
                      >
                        {/* Video Preview */}
                        <video
                          src={url}
                          className="w-full h-full object-cover"
                          muted
                        />

                        {/* Dark Overlay */}
                        <div className="absolute inset-0 bg-black/30"></div>

                        {/* Play Button */}
                        <div className="absolute inset-0 flex items-center justify-center">
                          <div className="w-6 h-6 bg-white rounded-full flex items-center justify-center shadow">
                            <div
                              className="ml-[2px]"
                              style={{
                                width: 0,
                                height: 0,
                                borderTop: "6px solid transparent",
                                borderBottom: "6px solid transparent",
                                borderLeft: "8px solid black",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          {/* Right Panel */}
          <div className="w-full md:w-1/2 p-4">
            <h2 className="lg:text-3xl md:text-lg text-md font-bold mb-2">
              {product?.mainTitle}
            </h2>
            <h2 className="lg:text-lg md:text-sm text-md font-bold mb-2">
              {currentTitle}
            </h2>

            <div className="flex mt-3 mb-3 items-center">
              <div className="relative inline-flex items-center">
                <span className="flex items-center text-lg">
                  <p>{currentPrice}</p>
                  <TbCurrencyTaka className="text-xl font-semibold" />
                </span>
                <div className="absolute left-0 right-0 top-1/2 h-[2px] bg-black"></div>
              </div>
              <div className="flex text-[#265fc9] items-center">
                <p className="text-lg font-bold ml-2">{originalPrice}</p>
                <TbCurrencyTaka className="text-xl font-semibold" />
              </div>
              {discountPercent > 0 && (
                <div className="mx-3 w-20 md:h-8 h-6 flex items-center justify-center rounded-full bg-red-500 text-white font-bold md:text-sm text-xs z-10">
                  {discountPercent}% OFF
                </div>
              )}
            </div>
            <div>
              {freeVariantDelivery === 1 && (
                <div className="mx-2 mb-3">
                  <div
                    className="
        inline-flex items-center gap-2
        bg-green-200 text-green-800
        border border-green-200
        px-3 py-1.5
        rounded-full
        font-semibold text-xs md:text-sm
        shadow-sm
      "
                  >
                    <BsTruck size={16} className="text-green-800" />
                    <span>ফ্রি ডেলিভারি</span>
                  </div>
                </div>
              )}
            </div>

            <p className=" mb-3 md:text-base text-sm whitespace-pre-line">
              {product?.extraDescription ?? ""}
            </p>
            {product?.weight > 0 && (
              <p className="mb-3 font-semibold">
                ওজনঃ {product.weight / 1000} KG
              </p>
            )}

            {/* Title Selection */}
            {variants.length > 1 && (
              <div className="mb-2">
                <div className="flex flex-wrap gap-2 mt-2">
                  {/* Variant Selection Dropdown */}
                  {variants.length > 1 && (
                    <div className="mb-5">
                      <p className="font-semibold mb-2">Select Variant</p>

                      <select
                        value={selectedVariant?.variant_id || ""}
                        onChange={(e) => {
                          const selected = variants.find(
                            (v) => v.variant_id === Number(e.target.value),
                          );

                          if (!selected) return;

                          setSelectedVariant(selected);
                          setSelectedImage({
                            variant: selected,
                            thumb: `https://backend.nuhababy.com/${selected.images[0].thumb}`,
                            original: `https://backend.nuhababy.com/${selected.images[0].original}`,
                            imageIndex: 0,
                            type: "image",
                          });
                        }}
                        className="w-full border px-3 py-2 rounded focus:outline-none focus:ring-1 focus:ring-[#265fc9]"
                      >
                        {variants.map((variant) => (
                          <option
                            key={variant.variant_id}
                            value={variant.variant_id}
                          >
                            {variant.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Size Selection */}
            {sizes.length > 0 && (
              <div className="mb-3">
                <p className="font-semibold">সাইজ : {selectedSize}</p>
                {sizes.length > 1 && (
                  <div className="flex flex-wrap gap-2 mt-2">
                    {sizes.map((size) => (
                      <button
                        key={size}
                        onClick={() => setSelectedSize(size)}
                        className={`border px-3 py-1 md:text-base text-sm rounded font-medium ${
                          selectedSize === size
                            ? "border-black text-white bg-[#265fc9]"
                            : "bg-white text-gray-400"
                        }`}
                      >
                        {size}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            )}
            {/* Color Selection */}
            <div className="mb-3">
              {colors.length > 0 && (
                <div>
                  <p className="font-semibold">রঙ : {selectedColor}</p>
                  {colors.length > 1 && (
                    <div className="flex flex-wrap gap-2 mt-2">
                      {colors.map((color) => (
                        <button
                          key={color}
                          onClick={() => setSelectedColor(color)}
                          className={`border px-3 py-1 md:text-base text-sm rounded font-medium ${
                            selectedColor === color
                              ? "border-black text-white bg-[#265fc9]"
                              : "bg-white text-gray-400"
                          }`}
                        >
                          {color}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              )}

              {/* Quantity & Actions */}
              {!isOutOfStock && (
                <>
                  <div className="flex justify-between items-end w-full gap-2">
                    <div className="mt-4 flex-none ">
                      <p className="mb-1 text-sm font-semibold text-slate-700">
                        Quantity
                      </p>
                      <div className="inline-flex items-center rounded-md border border-slate-300 bg-white">
                        <button
                          type="button"
                          disabled={quantity === 1}
                          onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                          className="inline-flex h-9 w-9 items-center justify-center disabled:cursor-not-allowed disabled:opacity-40"
                        >
                          <FaMinus className="text-xs" />
                        </button>
                        <span className="inline-flex min-w-10 items-center justify-center text-sm font-bold">
                          {quantity}
                        </span>
                        <button
                          type="button"
                          onClick={() => setQuantity((q) => q + 1)}
                          className="inline-flex h-9 w-9 items-center justify-center"
                        >
                          <FaPlus className="text-xs" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2 sm:mt-[20px] mt-[15px] mb-3">
                    {/* 1/3 width */}
                    <button
                      type="button"
                      onClick={handleAddToCart}
                      className="flex-[1] inline-flex items-center justify-center gap-2 rounded-md border border-gray-300 bg-[#265fc9] px-4 py-2.5 text-xs sm:text-sm font-bold text-white transition"
                    >
                      <FaShoppingCart />
                      এড টু কার্ট
                    </button>

                    {/* 2/3 width */}
                    <div className="flex-[2]">
                      <button
                        type="button"
                        onClick={handleOrderNow}
                        className="w-full rounded-md bg-[#FF0000] px-4 py-2 text-md font-bold text-white transition"
                      >
                        অর্ডার করুন
                      </button>
                    </div>
                  </div>
                  <div className="flex gap-2 sm:mt-[20px] my-3">
                    {/* 1/3 width */}

                    <a href={`tel:01971787661`} className="flex-[1]">
                      <button className="w-full whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-[#070050] px-4 py-2.5 text-xs sm:text-sm font-extrabold text-white transition">
                        <BiPhoneCall />
                        Call For Order
                      </button>
                    </a>

                    {/* 2/3 width */}
                    <a
                      href={`https://wa.me/8801971787661?text=${encodeURIComponent(whatsappMessage)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-[2]"
                    >
                      <button className="w-full whitespace-nowrap inline-flex items-center justify-center gap-2 rounded-md bg-green-800 px-4 py-2.5 text-xs sm:text-sm font-extrabold text-white transition">
                        <FaWhatsapp />
                        Order On WHATSAPP
                      </button>
                    </a>
                  </div>
                  <div className="flex p-4 border rounded mb-4 shadow my-5">
                    <div className="flex items-center mr-5">
                      <FaHeadphones className="text-3xl " />
                    </div>
                    <div>
                      <p lang="bn" className="font-bold mb-2">
                        অর্ডার করুন ফোনে
                      </p>
                      <p lang="bn" className="md:text-sm text-xs mt-1">
                        প্রোডাক্ট অর্ডার করতে সমস্যা হলে আমাদের সাথে যোগাযোগ
                        করুন।
                      </p>
                      <a
                        href={`tel:01971787661`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p className="text-[#265fc9] mt-1 md:text-sm text-xs">
                          01971787661
                        </p>
                      </a>
                    </div>
                  </div>
                </>
              )}

              {/* Social Icons */}
              <div className="md:flex gap-3 items-center mt-2">
                <p className="text-gray-700 text-sm md:mb-0 mb-3">
                  আমাদের সাথে যুক্ত থাকুনঃ
                </p>
                <div className="flex gap-4">
                  <a
                    href="https://www.facebook.com/share/1AoiGtts1W/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebook size={24} className="hover:text-blue-600" />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <AiFillTikTok size={24} className="hover:text-cyan-300" />
                  </a>
                  <a
                    href={`https://wa.me/8801971787661`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp size={24} className="hover:text-green-600" />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <FaInstagram size={24} className="hover:text-[#fbad50]" />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <FaYoutube size={24} className="hover:text-red-600" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="mx-auto px-4 md:py-6 pb-6">
          <div className="flex space-x-6 border-b border-gray-200 ">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`pb-2 px-4 font-semibold uppercase tracking-wide transition-all ${
                  activeTab === tab
                    ? "border-b-2 border-[#265fc9] text-black"
                    : "text-gray-500 hover:text-black"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
          <div className="container mx-auto text-gray-500">
            {getTabContent()}
          </div>
          <QuickAddDrawer
            isOpen={drawerOpen}
            onClose={() => setDrawerOpen(false)}
          />
        </div>

        {/* Related Products */}
        <div className="flex items-center border-b border-gray-200 w-full px-4 mb-5 container mx-auto">
          <div className="flex items-center space-x-2 relative pb-2">
            <FaShoppingCart className="text-xl text-black" />
            <span className="text-lg font-semibold text-black">
              সংশ্লিষ্ট প্রোডাক্ট
            </span>
            <div className="absolute -bottom-0.5 left-0 w-full h-[2px] bg-green-600 rounded-full"></div>
          </div>
        </div>
        <div className="py-4">
          <Suspense fallback={<div></div>}>
            <CardDesign likeData={products} loading={loading} error={error} />
          </Suspense>
        </div>

        <FooterSection />
        <ScreenScrollToTop />
      </div>
    </>
  );
};

export default ProductDetails;
